import { Image } from "@chakra-ui/react";

const TrashIcon = () => {
    return(
        <Image
            cursor="pointer"
            src="/images/icons/trash-delete.svg"
            transition="filter .2s"
            _hover={{
                transition: "filter .2s",
                filter: "brightness(.3)",
            }}
        />
    )
}

export { TrashIcon }